import { BaseQueryFn } from "@reduxjs/toolkit/dist/query";
import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { readFromStorage, removeFromStorage } from "../webStorage";
import { HOTEL_AI_URL } from "../../config";

const axiosConfig: AxiosRequestConfig = {
  baseURL: HOTEL_AI_URL,
};

const reservationAxios = axios.create(axiosConfig);

const logout = () => {
  removeFromStorage("accessToken");
  removeFromStorage("refreshToken");
  removeFromStorage("user");
  removeFromStorage("role");
  window.location.reload();
  // (window as any).Intercom('shutdown');
};

// reqeust intercpetor
reservationAxios.interceptors.request.use((config) => {
  const token = readFromStorage("accessToken");
  // const isValid = validateJWT(token);
  if (token) {
    return {
      ...config,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
      },
    };
  }
  return config;
});

// Add a response interceptor
reservationAxios.interceptors.response.use(
  (response) => {
    if (response?.data?.error === "No permission!") logout();
    return response;
  },
  async (error) => {
    const err = { ...error };
    if (error.response.status === 401) {
      const err = { ...error };
      const originalRequest = err.config;
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const response = await reservationAxios.post(
            "/outlook/refresh-token",
            { refreshToken: localStorage.getItem("googleRefreshToken") }
          );
          const { access_token, refresh_token } = response.data.tokens;
		  localStorage.setItem('googleAccessToken', access_token);
          localStorage.setItem("googleRefreshToken", refresh_token);
		  const newOriginalRequest = {
			...originalRequest,
			url: originalRequest.url.replace(/(accessToken=)[^&]+/, `accessToken=$${access_token}`)
		  } 
          return reservationAxios(newOriginalRequest);
        } catch (e) {
          try {
            const response = await reservationAxios.get("/gmail/auth-url");
            const { authUrl } = response.data;
            window.location.assign(authUrl);
          } catch (e) {
            console.error(e);
            logout();
          }
        }
      } else {
        logout();
      }
    }
    return Promise.reject(err);
  }
);

export const googleReservationAxiosQuery =
  (): BaseQueryFn<{
    url: string;
    method: AxiosRequestConfig["method"];
    data?: AxiosRequestConfig["data"];
  }> =>
  async ({ url, method, data }) => {
    const baseUrl = axiosConfig.baseURL;
    try {
      const result = await reservationAxios({
        url: baseUrl + url,
        method,
        data,
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: { status: err.response?.status, data: err.response?.data },
      };
    }
  };

export default googleReservationAxiosQuery;
